import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { MessageSmallIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { makeGetCommentsCountByIdSelector } from "~/store/selectors/selector.tasks.jsx";
import TaskObjectsCount from "./TaskObjectsCount";

export const CommentsCount = ({ id }) => {
  const getCommentsCountById = useMemo(makeGetCommentsCountByIdSelector, []);
  const count = useSelector((state) => getCommentsCountById(state, id));
  return count > 0 ? (
    <TaskObjectsCount
      iconType={MessageSmallIcon}
      count={count}
    />
  ) : null;
};

CommentsCount.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string, // string is used as placeholder ID until backend returns the real ID
    PropTypes.number,
  ]),
};
